<template>
	<div class="usi">
		<div class="usi__elm" :style="{ background: status(value).color }">
			<div class="usi__elm-label">
				{{ status(value).label }}
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
	props: {
		value: { type: Number, default: "" },
	},
})
export default class UiStatusIndicator extends Vue {
	public STATUS = {
		ACTIVE: 1,
		PROCESS: 0,
		WAITING_2: 2,
		WAITING_5: 5,
		PAUSE: 6,
		DELETED: 10,
		FREE: 11,
	};

	public LABEL = {
		ACTIVE: "Активен",
		PROCESS: "Загрузка",
		WAITING: "Ожидание",
		PAUSE: "Остановлен",
		DELETED: "Удалён",
		FREE: "Свободно",
	};

	/**
	 * Возвращает название статуса и цвет
	 * @param value
	 */
	public status(value: number): { label: string; color: string } {
		let label = "";
		let color = "";

		switch (value) {
			case this.STATUS.ACTIVE:
				label = this.LABEL.ACTIVE;
				color = "rgb(212, 248, 211)";
				break;
			case this.STATUS.DELETED:
				label = this.LABEL.DELETED;
				color = "rgb(251, 231, 233)";
				break;
			case this.STATUS.WAITING_2:
				label = this.LABEL.WAITING;
				color = "rgb(237, 231, 251)";
				break;
			case this.STATUS.WAITING_5:
				label = this.LABEL.WAITING;
				color = "rgb(237, 231, 251)";
				break;
			case this.STATUS.PAUSE:
				label = this.LABEL.PAUSE;
				color = "rgb(253, 249, 193)";
				break;
			case this.STATUS.PROCESS:
				label = this.LABEL.PROCESS;
				color = "rgb(255, 240, 187)";
				break;
		}
		return { label, color };
	}
}
</script>

<style scoped lang="scss">
.usi {
	&__elm {
		box-sizing: border-box;
		display: flex;
		justify-content: center;
		align-items: center;
		max-width: 110px;
		padding: 0 6px;
		height: 30px;
		border-radius: 6px;
	}

	&__elm-label {
		font-size: 14px;
		color: rgb(34, 34, 34);
	}
}
</style>
